import React, { useEffect, useState } from 'react';
import { Form, Spin } from 'antd';
import Box from '@iso/components/utility/box';
import ContentHolder from '@iso/components/utility/contentHolder';
import Select, { SelectOption } from '@iso/components/uielements/select';
import Input from '@iso/components/uielements/input';
import noDataImg from '@iso/assets/images/no-data-found.svg';
// import plusIcon from '@iso/assets/images/plusIcon.svg';
import refreshIcon from '@iso/assets/images/refresh.svg';
import CreateTaskHeader from '../../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import Button from '@iso/components/uielements/button';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../../../context/ContextProvider';
import { useContext } from 'react';
import axios from 'axios';
import api from '../../../../api';
import { customFilterOption, customSortOptions, formatErrors, hasPermission } from '../../../../context/helper';
import Alert from '@iso/components/Feedback/Alert';
import CreateTaskFooter from '../../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter';
import { useRef } from 'react';
import { DeploymentContext } from '../../../../context/deploymentContext';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import retriggerIcon from '@iso/assets/images/retriggerIcon.svg';
import CustomInfoTooltip from '../../../Dashboard/CustomComponents/CustomInfoTooltip';
import { CustomModal } from '../../../Dashboard/CustomComponents/PageLoader.style';
import useDebounce from '../../../Dashboard/CustomHooks/useDebounce';
import { fetchBranches } from '../../../../apis/Integrations';
import { AlertContext } from '../../../../context/alertContext';

const Option = SelectOption;

let boxTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: "1px",
};

let boxSubtitleStyle = {
    fontSize: "12px",
    lineHeight: "20px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontType: "regular",
}

let boxStyle = {
    border: '0',
    padding: "0",
    width: "100%"
}

let titleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontSize: "16px",
    fontWeight: "500"
}

let subtitleStyle = {
    fontSize: "14px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontType: "regular",
    fontWeight: "400"
}

let inputStyle = {
    padding: '4px 11px',
    color: 'rgba(0, 0, 0, 0.88)',
    fontSize: '14px',
    borderRadius: '6px',
    height: "40px"
}

let imgStyle = {
    width: '16px',
    height: '20px',
    marginRight: '10px'
}

const CustomAlert = styled(Alert)`
    .ant-alert-action {
        position: absolute;
        right: 0;
        bottom: 0;
        margin: 10px;
    }
`;



export default ({
    // handleSubmit,
    values,
    data,
    editing,
    submitCount,
    columnId,
    onCancel,
    onDelete,
    onSave,
    deployment,
    onEditCancel,
}) => {

    const [form] = Form.useForm();

    const { convertToBackend, convertToFrontend, currentProject, setCurrentProject, setOpenModel, setOpenRightDrawer, tempNodeData, tempEdgesData, setCurrentWorkflowData, setWorkflowData, setWorkflowNodeData, setWorkflowEdgesData, initialWorkflowData, setInitialWorkflowData, refreshProjectData, setRefreshProjectData, checkTryWithoutLogin, infraModuleData, setInfraModuleData } = useContext(AppContext);
    const { alertOptions, set_alertOptions } = useContext(AlertContext);
    const { deploymentData, setDeploymentData, setSelectedProject } = useContext(DeploymentContext);
    const sourceLocked = true;
    const [fetching, setFetching] = useState(false);
    const [componentLoading, setComponentLoading] = useState(false);
    // const [sources, setSources] = useState([]);
    const [accountsConnected, setAccountsConnected] = useState();
    const [sourceFetching, setSourceFetching] = useState(true);
    const [accountsPageCount, setAccountsPageCount] = useState(1);
    const [doneFetchingAccounts, setDoneFetchingAccounts] = useState(false);
    const [accountsFetching, setAccountsFetching] = useState(false);
    const PAGE_SIZE_ACCOUNTS = 10;
    const [openAppSourceDropdown, setOpenAppSourceDropdown] = useState(false);
    // const [openSource, setOpenSource] = useState(false);
    const [repoList, setRepoList] = useState();
    const [branchList, setBranchList] = useState();
    // const [myTask, setMyTask] = useState({ ...data });
    const [imageRepoList, setImageRepoList] = useState([]);
    // const [containerRegistryList, setContainerRegistryList] = useState([]);
    // const [containerRegs, setContainerRegs] = useState([]);
    const [sourceList, setSourceList] = useState([]);
    const [autoTriggerOptions, setAutoTriggerOptions] = useState();
    const [branchConfigDropdown, setBranchConfigDropdown] = useState();
    const [searchValue, setSearchValue] = useState("");
    const [branchSearchValue, setBranchSearchValue] = useState("");
    const [pageCount, setPageCount] = useState(1);
    const [fetchingBranches, setFetchingBranches] = useState(false);

    const [error, setError] = useState({
        status: false,
        msg: "Success"
    });
    const location = useLocation();
    const navigate = useNavigate();
    const targetRef = useRef(null);
    // const controllerRef = useRef(null);

    const repoUrlRegex = /(?:https?:\/\/)?(?:www\.)?(?:github\.com|gitlab\.com|\@bitbucket\.org)?\/([^/\s]+)\/([^/\s]+)/i;
    // https://github.com/Gautam-SquareOps/test.git
    // "https://squareops_test@bitbucket.org/atmosly/dev.git"
    const serviceNameRegex = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/;

    console.log("editing in infraSourceRightDrawer ", editing);
    console.log("data in infraSourceRightDrawer ", data);

    const [myAppData, setMyAppData] = useState(editing ? data : {
        id: "",
        serviceId: "",
        serviceCategory: "",
        columnId: columnId,
        // name: "",
        isPrivate: false,
        isOwner: true,
        accountId: "",
        accountName: "",
        sourceType: "Git Repositories",
        containerRegistry: {},
        imageRepo: "",
        source: "",
        // envs: [],
        repoUrl: "",
        repo: "",
        branch: "",
        branchConfig: "",
        branchConfigValue: [],
        buildType: "Manual",
        // dockerFilePath: "",
        // description: '',
        // cpu: '',
        // ram: '',
        // workflows: [],
        editing: false,
        created_at: new Date(),
        updated_at: new Date(),
    });

    const [imageRepoLoading, setImageRepoLoading] = useState(true);
    // const [envList, setEnvList] = useState([]);
    const [validatingRepo, setValidatingRepo] = useState(false);
    const [showError, setShowError] = useState("");
    const [branches, setBranches] = useState([]);
    const [automaticBranches, setAutomaticBranches] = useState([]);
    const [doneFetching, setDoneFetching] = useState(false);
    const [controller, setController] = useState();

    // this is to restrict multiple api calls on search input
    const debouncedFormUpdate = useDebounce((fieldsToUpdate) => {
        setBranchSearchValue(fieldsToUpdate);
        // whenever search is applied then search from first page
        setPageCount((prev) => {
            setBranches([]);
            setAutomaticBranches([]);
            setDoneFetching(false);
            return 1;
        });
        // setFetchingBranches(true);
    }, 500);

    // Source type, git account, repository and branch are collected on the Configuration
    // tab now and live in workflowBuilder.sourceConfig.config. Seed from there before the
    // first render settles: this drawer's own defaults are blank, so a new workspace would
    // otherwise open with the locked fields empty and every dependent row hidden.
    useEffect(() => {
        const configured = Object.fromEntries(
            Object.entries(infraModuleData?.workflowBuilder?.sourceConfig?.config || {})
                .filter(([, value]) => value !== undefined && value !== "")
        );
        const seeded = { ...myAppData, ...configured };
        // Belt and braces: the node hands this drawer sourceConfig.config as `data`, so a
        // config saved before Configuration started persisting sourceType would still open
        // blank and hide every field gated on it.
        if (!seeded.sourceType) {
            seeded.sourceType = "Git Repositories";
        }
        if (Object.keys(configured).length) {
            setMyAppData(seeded);
        }
        form.setFieldsValue({ ...seeded });
    }, []);

    useEffect(() => {
        let tempDropdown = [];
        let tempAutoTriggerDropdown = [];
        let sourceTypes = ["Git Repositories"];  // "Container Registry"
        let sourceOptions = [];

        ["Branch", "Wildcard Branch"].forEach((child, ind) => {         // , "Tags", "Pull request"
            tempDropdown.push(
                <Option key={child} name="branchConfig" data-id="" data-region={null} value={child}>
                    <div style={{ width: "100%", display: "flex" }}>
                        <p> {child} </p>
                    </div>
                </Option>
            );
        });

        ["Manual", "Automatic"].forEach((child, ind) => {
            tempAutoTriggerDropdown.push(
                <Option key={child} name="buildType" data-id="" data-region={null} value={child}>
                    <div style={{ width: "100%", display: "flex" }}>
                        <p> {child} </p>
                    </div>
                </Option>
            );
        });

        sourceTypes.forEach((val) => {
            sourceOptions.push(
                <Option key={val} value={val} name="sourceType">{val}</Option>
            );
        });

        setBranchConfigDropdown(tempDropdown);
        setAutoTriggerOptions(tempAutoTriggerDropdown);
        setSourceList(sourceOptions);
    }, []);

    useEffect(() => {
        if (editing) {
            console.log("myAppData initially :", myAppData);
            if (myAppData.source) {
                setMyAppData({
                    ...myAppData,
                    source: myAppData.source,
                    // source: `${myAppData.source.toUpperCase()}${myAppData.account_name ? ` (${myAppData.account_name})` : ""}`
                });
            }
            else {
                setMyAppData({
                    ...myAppData,
                    source: "public"
                })
            }
        }
    }, []);

    useEffect(() => {
        if (myAppData.source && (myAppData.accountId || myAppData.accountName)) {
            setFetching(true);
            getRepos(myAppData.accountId);
        }
        else if (myAppData.source && myAppData.source === "public") {
            setRepoList();
            setBranchList();
        }
    }, [myAppData.source, myAppData.accountId, myAppData.accountName]);

    useEffect(() => {
        if (sourceFetching && accountsPageCount === 1 || accountsPageCount > 1) {
            if (accountsPageCount === 1) {
                setAccountsConnected(undefined);
                setDoneFetchingAccounts(false);
            }
            setAccountsFetching(true);
            const url = `${process.env.REACT_APP_API_URI}/api/integration/account/list/?from_integrationlist=false&page=${accountsPageCount}&page_size=${PAGE_SIZE_ACCOUNTS}`;
            api.post(url, { category_id: 2, is_active: true })
                .then((res) => {
                    let data = res.data;
                    const results = data.data?.results ?? [];
                    console.log("integration/list data :", data);
                    if (data.status) {
                        const publicOption = (
                            <Option key="source-public" name="source" data-alias="" type="public" value="PUBLIC">
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "40px" }}>
                                    <span>PUBLIC</span>
                                </div>
                            </Option>
                        );
                        const integrateOption = (
                            <Option key="source-integration" name="source" data-alias="" type="integration" style={{ color: "white", background: "#1677ff" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "40px" }}>
                                    <span>Integrate New Account</span>
                                </div>
                            </Option>
                        );
                        const newOptions = [];
                        results.forEach((temp, ind) => {
                            if (temp.integration_state && temp.integration_state.toLowerCase() === "active") {
                                newOptions.push(
                                    <Option key={`source-${temp.id}-${ind}`} name="source" data-key={temp.id} type={temp.integration_type} value={`${temp.integration_type.toUpperCase()}${temp.alias ? ` (${temp.alias})` : ""}`} data-alias={temp.alias}>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "40px" }}>
                                            <span>{`${temp.integration_type.toUpperCase()}${temp.alias ? ` (${temp.alias})` : ""}`}</span>
                                        </div>
                                    </Option>
                                );
                            }
                        });
                        if (results.length < PAGE_SIZE_ACCOUNTS) setDoneFetchingAccounts(true);
                        setAccountsConnected((prev) => {
                            const middle = prev && prev.length > 2 ? prev.slice(1, -1) : [];
                            return accountsPageCount <= 1
                                ? [publicOption, ...newOptions, integrateOption]
                                : [publicOption, ...middle, ...newOptions, integrateOption];
                        });
                        if (accountsPageCount === 1) setSourceFetching(false);
                    }
                    else {
                        let err = formatErrors(data.error_details);
                        console.log("Err :", err);
                        if (accountsPageCount === 1) setSourceFetching(false);
                    }
                })
                .catch((err) => {
                    console.log("err :", err);
                    if (accountsPageCount === 1) setSourceFetching(false);
                })
                .finally(() => setAccountsFetching(false));
        }
    }, [sourceFetching, accountsPageCount]);

    // Auto focus error
    useEffect(() => {
        if (error.status) {
            scrollToElement();
        }
    }, [error.status]);

    // useEffect(() => {
    //     //if (myAppData.sourceType === "Container Registry") {
    //     if (myAppData.sourceType === "Container Registry") {
    //         let regOptions = [];
    //         api.get('/api/integration/container-registries/').then((res) => {
    //             let data = res.data;
    //             let arr = data.data.filter(val => val.status === true);
    //             arr.push("PUBLIC");
    //             if (data.status) {
    //                 arr.forEach((child, ind) => {
    //                     if (child !== "PUBLIC") {
    //                         regOptions.push(
    //                             <Option key={child.alias + ind + '!'} name={"containerRegistry"} data-id={child.id} data-region={child.region} value={!child.account_id ? `${child.alias} - ${child.integration_type}` : `${child.account_id}${child.alias && `(${child.alias})`} / ${child.region}`}>
    //                                 <div style={{ width: "100%", display: "flex" }}>
    //                                     <p> {!child.account_id ? `${child.alias} - ${child.integration_type}` : `${child.account_id}${child.alias && `(${child.alias})`} / ${child.region}`} </p>
    //                                 </div>
    //                             </Option>);
    //                     }
    //                     else {
    //                         regOptions.push(
    //                             <Option key={child} name={"containerRegistry"} data-id="" data-region={null} value={child}>
    //                                 <div style={{ width: "100%", display: "flex" }}>
    //                                     <p> {child} </p>
    //                                 </div>
    //                             </Option>);
    //                     }
    //                 });

    //                 setContainerRegistryList(regOptions);
    //                 setContainerRegs(arr);
    //             }
    //             else {
    //                 console.log("Error");
    //             }
    //         }).catch((err) => {
    //             console.log("Error");
    //         })
    //     }
    //     //}
    // }, [myAppData.sourceType]);


    useEffect(() => {
        const fetchImageRepos = () => {
            if (myAppData.containerRegistry && Object.keys(myAppData.containerRegistry).length > 0 && myAppData.containerRegistry !== "PUBLIC") {
                let imageRepos = [];
                api.get(`/api/integration/repositories/${myAppData.containerRegistry.id}/`).then((res) => {
                    let data = res.data;
                    if (data.status) {
                        data.data.forEach((val) => {
                            imageRepos.push(
                                <Option key={val} value={val} name="imageRepo">{val}</Option>
                            );
                        });
                        setImageRepoList(imageRepos);
                        setImageRepoLoading(false);
                    }
                    else {
                        console.log("Error");
                        setImageRepoLoading(false);
                    }
                }).catch((err) => {
                    console.log("Error");
                    setImageRepoLoading(false);
                });
            }
        }
        let myRepoTimeout = setTimeout(fetchImageRepos, 2000);
        return (() => clearTimeout(myRepoTimeout))
    }, [myAppData.containerRegistry]);

    useEffect(() => {
        async function fetchData() {
            try {
                console.log("myAppData while branches :", myAppData);
                console.log("branchSearchValue while branches :", branchSearchValue);
                console.log("pageCount while branches :", pageCount);
                console.log("not doneFetching while branches :", !doneFetching);

                controller?.abort();    // Aborting previous api call before call new one
                // controllerRef.current?.abort();    // trying with ref

                const newController = new AbortController();
                setController(newController);
                // controllerRef.current = newController;

                if ((myAppData?.repo || myAppData?.repoUrl) && pageCount && !doneFetching) {
                    setFetchingBranches(true);
                    console.log("I am here...");
                    if (myAppData.accountId === null || myAppData.accountId === "") {
                        let rawData = myAppData.repoUrl.split("/");
                        let owner = rawData[3];
                        let repoName = rawData[4];
                        if (repoName) {
                            repoName = repoName.split(".git")[0];
                        }
                        if (myAppData.repoUrl.includes("github.com")) {
                            console.log("I am github...");
                            fetch(`https://api.github.com/repos/${owner}/${repoName}/branches?per_page=100&page=${pageCount}&query=${branchSearchValue}`, {
                                signal: newController.signal
                            })
                                .then(async (res) => await res.json())
                                .then((data) => {
                                    console.log('branches data :', data);
                                    if (data.type !== "error") {
                                        if (data.message) {
                                            console.log("Please provide correct url");
                                        }
                                        else {
                                            let tempBranches = [];
                                            let tempAutomaticBranches = [];

                                            data.map((temp, ind) => {
                                                tempBranches.push(
                                                    <Option key={branches.length + ind} name="branch" value={temp.name}>
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                            <span>{temp.name}</span>
                                                        </div>
                                                    </Option>
                                                );

                                                tempAutomaticBranches.push(
                                                    <Option key={automaticBranches.length + ind} name="branchConfigValue" value={temp.name}>
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                            <span>{temp.name}</span>
                                                        </div>
                                                    </Option>
                                                );
                                            });

                                            setBranches((prev) => {
                                                // const allIn = tempBranches.every(item => prev.includes(item));
                                                if (data.length <= 99) {
                                                    setDoneFetching(true);
                                                    // return [...prev];
                                                }

                                                if (branchSearchValue && pageCount <= 1) {
                                                    return [...tempBranches]
                                                }
                                                else {
                                                    return [...prev, ...tempBranches]
                                                }
                                            });

                                            setAutomaticBranches((prev) => {
                                                // const allIn = tempAutomaticBranches.every(item => prev.includes(item));
                                                if (data.length <= 99) {
                                                    setDoneFetching(true);
                                                    // return [...prev];
                                                }

                                                // if there is search then don't append previous data
                                                if (branchSearchValue && pageCount <= 1) {
                                                    return [...tempAutomaticBranches]
                                                }
                                                else {
                                                    return [...prev, ...tempAutomaticBranches]
                                                }
                                            });
                                        }
                                    }
                                    else {
                                        toggleAlert("error", "Error", data.error?.message);
                                    }
                                })
                                .catch((error) => {
                                    console.error('Error fetching branches:', error);
                                });
                        }
                        else if (myAppData.repoUrl.includes("gitlab.com")) {
                            console.log("I am gitlab");
                            fetch(`https://gitlab.com/api/v4/projects/${owner}%2F${repoName}/repository/branches?per_page=100&page=${pageCount}&search=${branchSearchValue}`, {
                                signal: newController.signal
                            })
                                .then(async (res) => {
                                    let data = await res.json();
                                    if (data.type !== "error") {
                                        if (data.message) {
                                            console.log("Please provide correct url");
                                        }
                                        else {
                                            let tempBranches = [];
                                            let tempAutomaticBranches = [];

                                            // Although GitLab returns branches ordered by commit date,
                                            // we sort again to be sure.
                                            const sortedBranches = data.map(branch => ({
                                                name: branch.name,
                                                last_updated: branch.commit.committed_date
                                            }))
                                                // Sort descending by `last_updated` (same as `reverse=True`)
                                                .sort((a, b) => new Date(b.last_updated) - new Date(a.last_updated));

                                            sortedBranches.map((temp, ind) => {
                                                tempBranches.push(
                                                    <Option key={branches.length + ind} name="branch" value={temp.name}>
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                            <span>{temp.name}</span>
                                                        </div>
                                                    </Option>
                                                );

                                                tempAutomaticBranches.push(
                                                    <Option key={automaticBranches.length + ind} name="branchConfigValue" value={temp.name}>
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                            <span>{temp.name}</span>
                                                        </div>
                                                    </Option>
                                                );
                                            });

                                            setBranches((prev) => {
                                                // const allIn = tempBranches.every(item => prev.includes(item));
                                                if (sortedBranches.length <= 99) {
                                                    setDoneFetching(true);
                                                    // return [...prev];
                                                }

                                                if (branchSearchValue && pageCount <= 1) {
                                                    return [...tempBranches]
                                                }
                                                else {
                                                    return [...prev, ...tempBranches]
                                                }
                                            });

                                            setAutomaticBranches((prev) => {
                                                // const allIn = tempAutomaticBranches.every(item => prev.includes(item));
                                                if (sortedBranches.length <= 99) {
                                                    setDoneFetching(true);
                                                    // return [...prev];
                                                }

                                                // if there is search then don't append previous data
                                                if (branchSearchValue && pageCount <= 1) {
                                                    return [...tempAutomaticBranches]
                                                }
                                                else {
                                                    return [...prev, ...tempAutomaticBranches]
                                                }
                                            });
                                            // setBranches([...branches, ...tempBranches]);
                                            // setAutomaticBranches([...automaticBranches, ...tempAutomaticBranches]);
                                        }
                                    }
                                    else {
                                        toggleAlert("error", "Error", data.error?.message);
                                    }
                                }).catch((error) => {
                                    console.error('Error fetching branches:', error);
                                });
                        }
                        else {
                            console.log("I am at last");
                            fetch(`https://api.bitbucket.org/2.0/repositories/${owner}%2F${repoName}/refs/branches?sort=-target.date&pagelen=100&page=${pageCount}&q=name~"${branchSearchValue}"`, {
                                signal: newController.signal
                            })
                                .then(async (res) => {
                                    let data = await res.json();
                                    if (data.type !== "error") {
                                        if (data.message) {
                                            console.log("Please provide correct url");
                                        }
                                        else {
                                            let tempBranches = [];
                                            let tempAutomaticBranches = [];

                                            data.values?.map((temp, ind) => {
                                                tempBranches.push(
                                                    <Option key={branches.length + ind} name="branch" value={temp.name}>
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                            <span>{temp.name}</span>
                                                        </div>
                                                    </Option>
                                                );

                                                tempAutomaticBranches.push(
                                                    <Option key={automaticBranches.length + ind} name="branchConfigValue" value={temp.name}>
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                            <span>{temp.name}</span>
                                                        </div>
                                                    </Option>
                                                );
                                            });

                                            setBranches((prev) => {
                                                // const allIn = tempBranches.every(item => prev.includes(item));
                                                if (data.values.length <= 99) {
                                                    setDoneFetching(true);
                                                    // return [...prev];
                                                }

                                                if (branchSearchValue && pageCount <= 1) {
                                                    return [...tempBranches]
                                                }
                                                else {
                                                    return [...prev, ...tempBranches]
                                                }
                                            });

                                            setAutomaticBranches((prev) => {
                                                // const allIn = tempAutomaticBranches.every(item => prev.includes(item));
                                                if (data.values.length <= 99) {
                                                    setDoneFetching(true);
                                                    // return [...prev];
                                                }

                                                // if there is search then don't append previous data
                                                if (branchSearchValue && pageCount <= 1) {
                                                    return [...tempAutomaticBranches]
                                                }
                                                else {
                                                    return [...prev, ...tempAutomaticBranches]
                                                }
                                            });
                                            // setBranches([...branches, ...tempBranches]);
                                            // setAutomaticBranches([...automaticBranches, ...tempAutomaticBranches]);
                                        }
                                    }
                                    else {
                                        toggleAlert("error", "Error", data.error?.message);
                                    }
                                }).catch((error) => {
                                    console.error('Error fetching branches:', error);
                                });
                        }
                    }
                    else {
                        let branchesData = await fetchBranches(myAppData.accountId, myAppData.repo, 100, pageCount, branchSearchValue, newController.signal);
                        console.log("branchesData :", branchesData);
                        if (branchesData.status) {
                            let tempBranches = [];
                            let tempAutomaticBranches = [];

                            branchesData.data.map((temp, ind) => {
                                tempBranches.push(
                                    <Option key={branches.length + ind} name="branch" value={temp.name}>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                            <span>{temp.name}</span>
                                        </div>
                                    </Option>
                                );

                                tempAutomaticBranches.push(
                                    <Option key={automaticBranches.length + ind} name="branchConfigValue" value={temp.name}>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                            <span>{temp.name}</span>
                                        </div>
                                    </Option>
                                );
                            });

                            setBranches((prev) => {
                                // const allIn = tempBranches.every(item => prev.includes(item));
                                if (branchesData.data.length <= 99) {
                                    setDoneFetching(true);
                                    // return [...prev];
                                }

                                console.log("[...tempBranches] :", [...tempBranches]);
                                console.log("[...prev, ...tempBranches] :", [...prev, ...tempBranches]);

                                // if there is search then don't append previous data
                                if (branchSearchValue && pageCount <= 1) {
                                    return [...tempBranches]
                                }
                                else {
                                    return [...prev, ...tempBranches]
                                }
                            });

                            setAutomaticBranches((prev) => {
                                // const allIn = tempBranches.every(item => prev.includes(item));
                                if (branchesData.data.length <= 99) {
                                    setDoneFetching(true);
                                    // return [...prev];
                                }

                                // if there is search then don't append previous data
                                if (branchSearchValue && pageCount <= 1) {
                                    return [...tempAutomaticBranches]
                                }
                                else {
                                    return [...prev, ...tempAutomaticBranches]
                                }
                            });
                        }
                        else if (axios.isCancel(branchesData)) {
                            console.log("Request cancelled :", branchesData);
                            // return without setting Branches
                            return;
                        }
                    }
                    setFetchingBranches(false);
                }
                else {
                    setFetchingBranches(false);
                }
            } catch (err) {
                console.log("Error in fetch data:", err)
            }
        }

        fetchData();

        return () => {
            console.log("Abort controller called :", branchSearchValue);
            controller && controller.abort();
        }
    }, [myAppData.repo, myAppData.repoUrl, pageCount, branchSearchValue]);

    const scrollToElement = () => {
        console.log("Target ref: ", targetRef);
        targetRef.current.scrollIntoView({
            behavior: 'smooth',
            block: "center",
            inline: "center"
        });
    };

    const getRepos = (accountId) => {
        console.log('Going to get repos');
        let payload = {
            "account_id": accountId
        }

        api.post(process.env.REACT_APP_API_URI + "/api/integration/vcs/repos/", payload)
            .then((res) => {
                let data = res.data;
                console.log("repo/list data :", data);
                if (data.status) {
                    let repos = [];

                    data.data?.map((temp, ind) => {
                        repos.push(
                            <Option key={ind} name="repo" type={temp.name} value={temp.name} data-isprivate={temp.private} data-url={temp.repo_url} is-owner={temp.owner}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "40px" }}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <p>{temp.name}</p>
                                        <p style={{
                                            fontFamily: "Nunito Sans",
                                            fontSize: "10px",
                                            color: "lightgray"
                                        }}>Atmosly requires you to have repo ownership otherwise some functionalities may not work.</p>
                                    </div>
                                    <span>{temp.private ? "Private" : "Public"}</span>
                                </div>
                            </Option>
                        );
                    });

                    console.log('repos :', repos);
                    setRepoList(repos);
                    setFetching(false);
                }
                else {
                    let err = formatErrors(data.error_details);
                    console.log("Error :", err);
                    setFetching(false);
                }
            })
            .catch((err) => {
                console.log("err :", err);
                setFetching(false);
                if (err === "Try without login") {
                }
                else {
                    toggleAlert("error", "Error", "Something went wrong. Please try again.");
                }
            });
    }

    const handelClick = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
                setData: "",
                columnId: "",
                tabSelected: "",
            },
        });
    }

    // let myTitle = (title, required = true) => (
    //     <div>
    //         {required && <span style={{ marginRight: "2px", color: "red" }}>*</span>}
    //         {/* <img src={TitleIcon} style={imgStyle} alt="image" /> */}
    //         <span>{title}</span>
    //     </div>
    // );

    const getServiceCategoryId = (type) => {
        let serviceCategoryId = null;
        if (currentProject.serviceCategories) {
            currentProject.serviceCategories.map((temp, idx) => {
                if (temp.type === type) {
                    serviceCategoryId = temp.id
                }
            });

            console.log('serviceCategoryId :', serviceCategoryId);
            return serviceCategoryId;
        }
        else {
            return myAppData.serviceCategory;
        }
    }

    const saveService = () => {
        console.log('myAppData in addService :', myAppData);
        console.log('currentProject in addService :', currentProject);

        let payload = {
            // "name": myAppData.name,
            "description": myAppData.description,
            // "service_type": convertToBackend[myAppData.columnId],
            "service_category": getServiceCategoryId(convertToBackend[myAppData.columnId]),
            "service_icon": null,
            "config": {
                ...myAppData,
                account_id: myAppData.accountId,
                repo_url: myAppData.repoUrl,
                repo_name: myAppData.repo,
                is_private: myAppData.isPrivate,
                cpu: myAppData.cpu === "" ? null : parseInt(myAppData.cpu),
                ram: myAppData.ram === "" ? null : parseInt(myAppData.ram),
                is_owner: myAppData.isOwner ? myAppData.isOwner : false,

                app_source_type: myAppData.sourceType === "Git Repositories" ? 1 : 0,
                container_registry_id: myAppData.sourceType === "Git Repositories" ? null : myAppData.containerRegistry.id ? myAppData.containerRegistry.id : null,
                container_registry_type: myAppData.containerRegistry === "PUBLIC" ? 0 : 1,
                repository_name: myAppData.imageRepo,
            },
            "project": currentProject.id
        }

        delete payload.config.id;
        delete payload.config.title;
        delete payload.config.columnId;
        delete payload.config.description;
        delete payload.config.serviceId;
        delete payload.config.serviceCategory;
        delete payload.config.accountId;
        delete payload.config.accountName;
        delete payload.config.repoUrl;
        delete payload.config.repo;
        delete payload.config.isPrivate;
        delete payload.config.created_at;
        delete payload.config.updated_at;
        delete payload.config.isOwner;
        delete payload.config.sourceType;
        delete payload.config.containerRegistry;
        delete payload.config.imageRepo;
        console.log('payload in updateService :', payload);

        // let formData = new FormData();
        // formData.append('data', JSON.stringify(payload));

        api.post(`${process.env.REACT_APP_API_URI}/api/project_env/services/`, payload, /*{
            'Content-Type': 'multipart/form-data',
        }*/)
            .then((res) => {
                let data = res.data;
                console.log("create services data :", data);
                if (data.status) {
                    // update column
                    currentProject.columns[columnId].task_orders.push(currentProject.tasks.length);

                    let myTask = {
                        ...myAppData,
                        id: currentProject.tasks.length,
                        name: data.data.name,
                        title: data.data.name,
                        description: data.data.description,
                        columnId: convertToFrontend[data.data.type],
                        serviceId: data.data.id,
                        serviceCategory: data.data.service_category,
                        accountId: data.data.configuration["account_id"],
                        accountName: data.data.configuration["account_name"],
                        repoUrl: data.data.configuration["repo_url"],
                        repo: data.data.configuration["repo_name"],
                        isOwner: data.data.configuration["is_owner"],
                        isPrivate: data.data.configuration["is_private"],
                        webhook_info: data.data.webhook_info,
                        ...data.data.configuration
                    }

                    delete myTask.account_id;
                    delete myTask.account_name;
                    delete myTask.repo_url;
                    delete myTask.repo_name;
                    delete myTask.is_private;
                    // update tasks
                    currentProject.tasks.push(myTask);

                    setCurrentProject({ ...currentProject, columns: currentProject.columns, tasks: [...currentProject.tasks] });
                    localStorage.setItem("Project", JSON.stringify({ ...currentProject, columns: currentProject.columns, tasks: [...currentProject.tasks] }));
                    let depData = JSON.parse(localStorage.getItem("deploymentData"));
                    if (depData && depData.projectId === currentProject.id) {
                        setDeploymentData({ ...depData, projectId: 0, projectName: "" });
                        localStorage.setItem("deploymentData", JSON.stringify({ ...depData, projectId: 0, projectName: "" }));
                        setSelectedProject({});
                        localStorage.removeItem("selectedProject");
                    }
                    handelClick();
                    toggleAlert("success", "Success", "Saved Service Successfully.");
                    setRefreshProjectData(refreshProjectData => !refreshProjectData);
                }
                else {
                    let err = formatErrors(data.error_details);
                    console.log("Error :", err);
                    toggleAlert("error", "Error", err);
                }
            })
            .catch((err) => {
                console.log("err :", err);
                toggleAlert("error", "Error", "Something went wrong. Please try again.");
            });
    }

    const updateService = () => {
        console.log('myAppData in updateService :', myAppData);
        let payload = {
            // "name": myAppData.name,
            // "service_type": convertToBackend[myAppData.columnId],
            "service_category": getServiceCategoryId(convertToBackend[myAppData.columnId]),
            "description": myAppData.description,
            "config": {
                ...myAppData,
                account_id: myAppData.accountId,
                repo_url: myAppData.repoUrl,
                repo_name: myAppData.repo,
                is_private: myAppData.isPrivate,
                cpu: myAppData.cpu === "" ? null : parseInt(myAppData.cpu),
                ram: myAppData.ram === "" ? null : parseInt(myAppData.ram),
                is_owner: myAppData.isOwner ? myAppData.isOwner : false,

                app_source_type: myAppData.sourceType === "Git Repositories" ? 1 : 0,
                container_registry_id: myAppData.sourceType === "Git Repositories" ? undefined : myAppData.containerRegistry.id ? myAppData.containerRegistry.id : null,
                container_registry_type: myAppData.sourceType === "Container Registry" ? myAppData.containerRegistry === "PUBLIC" ? 0 : 1 : undefined,
                repository_name: myAppData.sourceType === "Git Repositories" ? undefined : myAppData.imageRepo,
            }
        }

        console.log("Ram and cpu: ", payload);

        delete payload.config.id;
        delete payload.config.name;
        delete payload.config.columnId;
        delete payload.config.description;
        delete payload.config.serviceId;
        delete payload.config.serviceCategory;
        delete payload.config.accountId;
        delete payload.config.accountName;
        delete payload.config.repoUrl;
        delete payload.config.repo;
        delete payload.config.isPrivate;
        delete payload.config.created_at;
        delete payload.config.updated_at;
        delete payload.config.isOwner;
        delete payload.config.sourceType;
        delete payload.config.containerRegistry;
        delete payload.config.imageRepo;
        console.log('payload in updateService :', payload);

        // let formData = new FormData();
        // formData.append('data', JSON.stringify(payload));
        api.patch(`${process.env.REACT_APP_API_URI}/api/project_env/services/${myAppData.serviceId}/`, payload, {
            'Content-Type': 'multipart/form-data',
        })
            .then((res) => {
                let data = res.data;
                console.log("update in app data :", data);
                if (data.status) {
                    currentProject.tasks.forEach((temp, idx) => {
                        if (temp && (temp.serviceId === myAppData.serviceId)) {
                            currentProject.tasks[idx] = { ...myAppData, webhook_info: data.data.webhook_info };
                        }
                    });
                    console.log('currentProject :', currentProject);
                    setCurrentProject({ ...currentProject });
                    localStorage.setItem("Project", JSON.stringify({ ...currentProject }));
                    let depData = JSON.parse(localStorage.getItem("deploymentData"));
                    if (depData && depData.projectId === currentProject.id) {
                        setDeploymentData({ ...depData, projectId: 0, projectName: "" });
                        localStorage.setItem("deploymentData", JSON.stringify({ ...depData, projectId: 0, projectName: "" }));
                        setSelectedProject({});
                        localStorage.removeItem("selectedProject");
                    }
                    handelClick();
                    toggleAlert("success", "Success", "Updated service successfully.");
                    setRefreshProjectData(refreshProjectData => !refreshProjectData);
                }
                else {
                    let err = formatErrors(data.error_details);
                    console.log("Error :", err);
                    setError({
                        status: true,
                        msg: err
                    });
                    toggleAlert("error", "Error", err);
                }
            })
            .catch((err) => {
                console.log("err :", err);
                if (err === "Try without login") {
                }
                else {
                    // handelClick();
                    setError({
                        status: true,
                        msg: "Something went wrong. Please try again."
                    });
                    toggleAlert("error", "Error", "Something went wrong. Please try again.");
                }
            });
    }
    const normaliseBranchConfig = (config) => {
        const next = { ...config };
        const current = next.branchConfigValue;
        if (next.branchConfig === "Branch") {
            next.branchConfigValue = Array.isArray(current) ? current : (current ? [current] : []);
        }
        else if (next.branchConfig === "Wildcard Branch") {
            next.branchConfigValue = Array.isArray(current) ? (current[0] || "") : (current || "");
        }
        return next;
    };

    const saveTasks = () => {
        console.log('myAppData in saveTasks :', myAppData);
        console.log('setInfraModuleData in saveTasks :', setInfraModuleData);

        const sourceConfigToStore = normaliseBranchConfig(myAppData);

        if(!infraModuleData.workflowBuilder){
            infraModuleData["workflowBuilder"] = {
                sourceConfig: {
                config: {...sourceConfigToStore}
            }}
        }
        else if (!infraModuleData.workflowBuilder.sourceConfig){
            infraModuleData.workflowBuilder["sourceConfig"] = {
                config: {...sourceConfigToStore}
            };
        }
        else {
            infraModuleData.workflowBuilder.sourceConfig["config"] = {...sourceConfigToStore};
        }

        setInfraModuleData((prev) => ({
            ...prev,
            workflowBuilder: {
                ...infraModuleData.workflowBuilder
            }
        }));

        localStorage.setItem("InfraModule", JSON.stringify({
            ...infraModuleData,
            workflowBuilder: {
                ...infraModuleData.workflowBuilder
            }
        }));

        handelClick();
    }

    const updateTasks = () => {
        // currentProject.tasks.forEach((temp, idx) => {
        //     if (temp && (temp.id === myAppData.id)) {
        //         currentProject.tasks[idx] = myAppData;
        //     }
        // });
        // console.log('currentProject :', currentProject);
        // setCurrentProject({ ...currentProject });
        // localStorage.setItem("Project", JSON.stringify({ ...currentProject }));
        handelClick();
    }

    const handelSaveTask = async () => {
        console.log("myAppData in handelSaveTask :", myAppData);
        console.log("validatingRepo :", validatingRepo);
        console.log("showError :", showError);
        if (showError === "" && !validatingRepo) {
            if (!myAppData.sourceType || myAppData.sourceType === "") {
                setError({
                    status: true,
                    msg: "Please fill all Fields marked with *"
                })
            }
            else if (!myAppData.source && myAppData.sourceType === "Git Repositories") {
                setError({
                    status: true,
                    msg: "Please fill all Fields marked with *"
                })
            }
            else if (myAppData.sourceType === "Container Registry" && Object.keys(myAppData.containerRegistry).length === 0) {
                console.log("Enters1");
                setError({
                    status: true,
                    msg: "Please fill all Fields marked with *"
                })
            }
            else if (myAppData.sourceType === "Container Registry" && (myAppData.imageRepo === "" || !myAppData.imageRepo)) {
                console.log("Enters2");
                setError({
                    status: true,
                    msg: "Please fill all Fields marked with *"
                })
            }
            else if ((myAppData.source === "public" && myAppData.sourceType === "Git Repositories") && !myAppData.repoUrl) {
                console.log("Enters3");
                console.log("Not repo url...");
                setError({
                    status: true,
                    msg: "Please fill all Fields marked with *"
                });
            }
            else if ((myAppData.source !== "public" && myAppData.sourceType === "Git Repositories") && !myAppData.repo) {
                console.log("Enters4");
                console.log("Not repo....", myAppData.source);
                setError({
                    status: true,
                    msg: "Please fill all Fields marked with *"
                });
            }
            else if ((myAppData.source == "public" && myAppData.sourceType === "Git Repositories") && (!myAppData.repoUrl.endsWith(".git"))) {
                console.log("Enters5");
                setError({
                    status: true,
                    msg: "Please provide correct Repo Url"
                });
            }
            else if ((myAppData.source == "public" && myAppData.sourceType === "Git Repositories") && (!repoUrlRegex.test(myAppData.repoUrl))) {
                console.log("Enters6");
                setError({
                    status: true,
                    msg: "Please provide correct Repo Url"
                });
            }
            else if (myAppData.source === "public" && myAppData.sourceType === "Git Repositories" && (myAppData.repoUrl.startsWith(" ") || myAppData.repoUrl.endsWith(" "))) {
                console.log("Enters7");
                setError({
                    status: true,
                    msg: "Please remove any leading or trailing spaces from Repo Url"
                });
            }
            else if (myAppData.cpu && /\/d*/.test(myAppData.cpu)) {
                setError({
                    status: true,
                    msg: "Please provide correct CPU."
                });
            }
            else if (myAppData.ram && /\/d*/.test(myAppData.ram)) {
                setError({
                    status: true,
                    msg: "Please provide correct RAM."
                });
            }
            else if (location.pathname.includes("/all-projects/project/")) {
                saveService();
            }
            else {
                try {
                    const values = await form.validateFields();
                    console.log('Success:', values);
                    saveTasks();
                }
                catch (errorInfo) {
                    console.log('Failed:', errorInfo);
                    // setError({
                    //     status: true,
                    //     msg: "Please fill all Fields marked with *"
                    // });
                }
            }
        }
    }

    const handelUpdateTask = () => {
        if (showError === "" && !validatingRepo) {
            // console.log("regex :", serviceNameRegex.test(myAppData.name));
            console.log("myAppData in handelUpdateTask :", myAppData);

            if (!myAppData.sourceType || myAppData.sourceType === "") {
                setError({
                    status: true,
                    msg: "Please fill all Fields marked with *"
                })
            }
            else if (myAppData.sourceType === "Container Registry" && Object.keys(myAppData.containerRegistry).length === 0) {
                console.log("Enters1");
                setError({
                    status: true,
                    msg: "Please fill all Fields marked with *"
                })
            }
            else if (myAppData.sourceType === "Container Registry" && (myAppData.imageRepo === "" || !myAppData.imageRepo)) {
                console.log("Enters2");
                setError({
                    status: true,
                    msg: "Please fill all Fields marked with *"
                })
            }
            else if ((myAppData.source === "public" && myAppData.sourceType === "Git Repositories") && !myAppData.repoUrl) {
                console.log("Enters3");
                console.log("Not repo url...");
                setError({
                    status: true,
                    msg: "Please fill all Fields marked with *"
                });
            }
            else if ((myAppData.source !== "public" && myAppData.sourceType === "Git Repositories") && !myAppData.repo) {
                console.log("Enters4");
                console.log("Not repo....", myAppData.source);
                setError({
                    status: true,
                    msg: "Please fill all Fields marked with *"
                });
            }
            else if ((myAppData.source == "public" && myAppData.sourceType === "Git Repositories") && (!myAppData.repoUrl.endsWith(".git"))) {
                console.log("Enters5");
                setError({
                    status: true,
                    msg: "Please provide correct Repo Url"
                });
            }
            else if ((myAppData.source == "public" && myAppData.sourceType === "Git Repositories") && (!repoUrlRegex.test(myAppData.repoUrl))) {
                console.log("Enters6");
                setError({
                    status: true,
                    msg: "Please provide correct Repo Url"
                });
            }
            else if (myAppData.source === "public" && myAppData.sourceType === "Git Repositories" && (myAppData.repoUrl.startsWith(" ") || myAppData.repoUrl.endsWith(" "))) {
                console.log("Enters7");
                setError({
                    status: true,
                    msg: "Please remove any leading or trailing spaces from Repo Url"
                });
            }
            else if (myAppData.cpu && /\/d*/.test(myAppData.cpu)) {
                setError({
                    status: true,
                    msg: "Please provide correct CPU."
                });
            }
            else if (myAppData.ram && /\/d*/.test(myAppData.ram)) {
                setError({
                    status: true,
                    msg: "Please provide correct RAM."
                });
            }
            else if (location.pathname.includes("/all-projects/project/")) {
                updateService();
            }
            else {
                updateTasks();
            }
        }
    }

    const handelChange = (e) => {
        // console.log('e.target.value :', e.target.value);
        // https://github.com/Gautam-SquareOps/test.git
        let val = e.target.value;
        // console.log("e.target.value :", e.target.value);

        if (e.target.name === "cpu" && (val[0] === 0 || e.target.value < 0 || val.length > 10)) {
            return;
        }
        else if (e.target.name === "ram" && (e.target.value < 0 || val.length > 10 || val[0] === 0)) {
            return;
        }
        else if (e.target.name === "repoUrl") {
            console.log("Changing repoUrl...");
            setMyAppData({ ...myAppData, [e.target.name]: e.target.value, branch: "" });
            form.setFieldsValue({ ...myAppData, [e.target.name]: e.target.value, branch: "" });
            setPageCount((prev) => {
                setBranches([]);
                setAutomaticBranches([]);
                setDoneFetching(false);
                return 1
            });
            // setBranchConfigDropdown([]);
            setError({
                status: false,
                msg: ""
            });
        }
        else {
            setMyAppData({ ...myAppData, [e.target.name]: e.target.value });
            form.setFieldsValue({ ...myAppData, [e.target.name]: e.target.value });
            setError({
                status: false,
                msg: ""
            });
        }
    }

    const handleSelectChange = (value, event) => {
        // myClusterData.prod[event.name] = value;
        console.log("event :", event);
        console.log("value :", value);
        if (event.name === "source" && event["data-key"]) {
            setMyAppData({ ...myAppData, [event.name]: event.type, repo: "", repoUrl: "", dockerFilePath: "", accountId: event["data-key"], branch: "", accountName: event["data-alias"], isPrivate: false });
            form.setFieldsValue({ ...myAppData, [event.name]: event.type, repo: "", repoUrl: "", dockerFilePath: "", accountId: event["data-key"], branch: "", accountName: event["data-alias"], isPrivate: false });
            setPageCount((prev) => {
                setBranches([]);
                setAutomaticBranches([]);
                setDoneFetching(false);
                return 1
            });
        }
        else if ((event.name === "source") && (event.type === "public")) {
            setMyAppData({ ...myAppData, [event.name]: event.type, repo: "", repoUrl: "", dockerFilePath: "", accountId: "", accountName: "", branch: "", isPrivate: false });
            form.setFieldsValue({ ...myAppData, [event.name]: event.type, repo: "", repoUrl: "", dockerFilePath: "", accountId: "", accountName: "", branch: "", isPrivate: false });
            setPageCount((prev) => {
                setBranches([]);
                setAutomaticBranches([]);
                setDoneFetching(false);
                return 1
            });
            return;
        }
        else if (event.name === "repo") {
            // getBranches(event.type);
            console.log('event["data-url"] :', event["data-url"]);
            console.log('event["data-isprivate"] :', event["data-isprivate"]);
            setMyAppData({ ...myAppData, [event.name]: event.type, repoUrl: event["data-url"], branch: "", branchConfig: "", branchConfigValue: "", isPrivate: event["data-isprivate"], isOwner: event["is-owner"] });
            form.setFieldsValue({ ...myAppData, [event.name]: event.type, repoUrl: event["data-url"], branch: "", branchConfig: "", branchConfigValue: "", isPrivate: event["data-isprivate"], isOwner: event["is-owner"] });
            setPageCount((prev) => {
                setBranches([]);
                setAutomaticBranches([]);
                setDoneFetching(false);
                return 1
            });
        }
        else if (event.type === "integration") {
            handelClick();
            window.open(`${process.env.REACT_APP_GOOGLE_REDIRECT_URI}/integrations`, "_blank");
            return;
        }
        else if (event.name === "sourceType" || event.name === "imageRepo") {
            if (event.name === "sourceType") {
                myAppData.source = "";
                myAppData.containerRegistry = {};
                myAppData.imageRepo = "";
                myAppData.repoUrl = "";
                setShowError("");
            }
            console.log("Enters sourceType: ", event.name, value);
            setMyAppData({ ...myAppData, [event.name]: value });
            form.setFieldsValue({ ...myAppData, [event.name]: value });
        }
        else if (event.name === "branch") {
            // On an Automatic source the trigger rule moves with the branch instead of being
            // cleared, so the Source node and this panel never show different branches — and
            // a workspace cannot end up triggering on one branch while checking out another.
            const branchPatch = myAppData.buildType === "Automatic"
                ? { branchConfig: "Branch", branchConfigValue: event.value ? [event.value] : [] }
                : { branchConfig: "", branchConfigValue: "" };
            setMyAppData({ ...myAppData, [event.name]: event.value, ...branchPatch });
            form.setFieldsValue({ ...myAppData, [event.name]: event.value, ...branchPatch });

            if (branchSearchValue !== "") {
                setPageCount((prev) => {
                    setBranches([]);
                    setAutomaticBranches([]);
                    setDoneFetching(false);
                    return 1
                });
            }
        }
        else if (event.name === "branchConfig") {
            // Switching the rule starts its value empty, same as the Workflow builder — the
            // two shapes are not interchangeable.
            setMyAppData({ ...myAppData, [event.name]: event.value, branchConfigValue: event.value === "Branch" ? [] : "" });
            form.setFieldsValue({ ...myAppData, [event.name]: event.value, branchConfigValue: event.value === "Branch" ? [] : "" });
        }
        else if (event.name === "buildType") {
            let triggerPatch;
            if (event.value === "Automatic") {
                const nextConfig = myAppData.branchConfig || "Branch";
                const currentValue = myAppData.branchConfigValue;
                triggerPatch = {
                    branchConfig: nextConfig,
                    branchConfigValue: nextConfig === "Branch"
                        ? (myAppData.branch ? [myAppData.branch] : [])
                        : (Array.isArray(currentValue) ? (currentValue[0] || "") : (currentValue || "")),
                };
            }
            else {
                triggerPatch = { branchConfig: "", branchConfigValue: "" };
            }
            setMyAppData({ ...myAppData, [event.name]: event.value, ...triggerPatch });
            form.setFieldsValue({ ...myAppData, [event.name]: event.value, ...triggerPatch });
        }
        else {
            if (event.name === "containerRegistry") {
                myAppData.imageRepo = "";
            }
            setMyAppData({ ...myAppData, [event.name]: event.type });
            form.setFieldsValue({ ...myAppData, [event.name]: event.type });
        }

        setError({
            status: false,
            msg: ""
        });
        setShowError("");
    };

    const handleMultiSelectChange = (value, event) => {
        // integration-redirect
        console.log("inside handleMultiSelectChange event :", event);
        console.log("inside handleMultiSelectChange value :", value);


        setMyAppData({ ...myAppData, 'branchConfigValue': value });
        form.setFieldsValue({ ...myAppData, 'branchConfigValue': value });

        console.log("handle branchSearchValue :", branchSearchValue);
        // setBranchSearchValue("");

        // setPageCount((prev) => {
        //     setAutomaticBranches([]);
        //     setDoneFetching(false);
        //     return 1
        // });
    }

    const handleSource = (event, value) => {
        console.log("handleSource event.target :", event.target);
        console.log("handleSource event.target.tagName :", event.target.tagName);
        console.log("handleSource :", value);
        // if(event.target?.tagName !== "INPUT"){
        if (!value) {
            setTimeout(() => {
                setOpenAppSourceDropdown(value);
            }, 300);
            // setOpenSource(false);
        }
        else {
            setOpenAppSourceDropdown(!openAppSourceDropdown);
            // setOpenSource(!openSource);
        }
        // }
    }

    const handleAccountsPopupScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        if (!doneFetchingAccounts && (scrollHeight - scrollTop <= clientHeight + 10) && !accountsFetching) {
            setAccountsPageCount((prev) => prev + 1);
            setAccountsFetching(true);
        }
    };

    const handleAppSourceRefresh = () => {
        console.log("handleAppSourceRefresh :", sourceFetching);
        setAccountsPageCount(1);
        setDoneFetchingAccounts(false);
        setSourceFetching(true);
        // setOpenAppSourceDropdown(false);
    }

    const onDeleteWorkflow = (data) => {
        setComponentLoading(true);
        setOpenModel({
            modalType: false,
            modalProps: {
                data: null,
            },
        });
        const id = data?.id;

        api.delete(`${process.env.REACT_APP_API_URI}/api/pipelines/workflows/delete/${id}/`)
            .then((res) => {
                let data = res.data;
                console.log("update in app data :", data);
                if (data.status) {
                    toggleAlert("success", "Success", "Workflow destroyed successfully.");
                    setCurrentProject((currentProject) => {
                        const taskIdx = currentProject?.tasks?.findIndex((task) => task.serviceId === myAppData.serviceId);
                        const workflows = currentProject?.tasks[taskIdx]?.workflows?.filter((workflow) => workflow.id !== id);
                        currentProject.tasks[taskIdx].workflows = [...workflows];
                        return currentProject;
                    });
                    const project = JSON.parse(localStorage.getItem("Project"));
                    const taskIdx = currentProject?.tasks?.findIndex((task) => task.serviceId === myAppData.serviceId);
                    const workflows = project?.tasks[taskIdx]?.workflows?.filter((workflow) => workflow.id !== id);
                    console.log("Getting the data.....", workflows, id);

                    project.tasks[taskIdx].workflows = [...workflows];

                    localStorage.setItem("Project", JSON.stringify({ ...project }))
                    // setRefreshProjectData(!refreshProjectData);
                    // set component loading to false after 1s as Project data is taking time.
                    // setTimeout(() => {
                    setComponentLoading(false);
                    handelClick();
                    // }, 1000);
                }
                else {
                    let err = formatErrors(data.error_details);
                    console.log("Error :", err);
                    toggleAlert("error", "Error", err);
                    setComponentLoading(false);
                    handelClick();
                }
            })
            .catch((err) => {
                console.log("error in deleting workflow :", err);
                toggleAlert("error", "Error", "Something went wrong. Please try again.");
                setComponentLoading(false);
                handelClick();
            });
    }

    const deleteWorkflow = (e, data) => {
        e.stopPropagation();
        console.log("inside deleteWorkflow :", data);
        if ((data?.environments && data?.environments.length > 0 && myAppData.canDeleteWorkflow) || !data?.environments || data?.environments.length <= 0) {
            console.log("inside deleteWorkflow :", data);
            data.title = data?.workflowName;
            data.name = data?.workflowName;

            setOpenModel({
                modalType: 'DELETE_TASKS',
                modalProps: {
                    data: data,
                    title: "Workflow",
                    subTitle: "",
                    subTitle2: `Please provide the name of the workflow to be destroyed`,
                    subTitle3: `PLEASE NOTE: All related workflow data from Atmosly will be destroyed after 7 days, and the workflow record won't be visible in the workflow list.`,
                    onDelete: onDeleteWorkflow,
                    columnId: null,
                },
            });
        }
    }

    function toggleAlert(type, message, description) {
        set_alertOptions(alertOptions => ({
            status: true,
            type: type,
            message: message,
            description: description,
        }));

        // opacity=0 after 10sec
        setTimeout(() => {
            set_alertOptions(alertOptions => ({
                status: false,
                type: type,
                message: message,
                description: description,
            }));
        }, 5 * 1000);
    }

    const filterOption = (input, option) => {
        if (option.key) {
            return (option?.props.type.toLowerCase() ?? '').includes(input.toLowerCase())
        }
    };


    const handleClick = (e, temp) => {
        if (hasPermission('view_pipeline')) {
            console.log("handleClick...");
            handelClick();
            // navigate(`/all-projects/project/${currentProject.id}/service/${myAppData.serviceId}/workflow/${temp.id}`, {
            navigate(`/application-blueprint/application/${myAppData.serviceId}/workflow/${temp.id}`, {
                state: {
                    data: {
                        ...temp,
                        serviceId: myAppData.serviceId
                    },
                    from: "renderCreateAppForm"
                }

            });
        }
    };

    // No repo_url pre-flight call for public sources. That endpoint
    // (/api/project_env/projects/repo_url) belongs to the application-service flow and
    // requires an `app_name`, which a workspace does not have — so it only ever returned
    // 400. Reachability is already proven by the branch listing below: it hits the
    // provider anonymously, exactly as the run pod's clone will, so a URL that is not
    // really public shows up there as an empty branch list.

    const retriggerWebhook = () => {
        setOpenModel({
            modalType: "CONFIRM_ACTION",
            modalProps: {
                title: "Confirm Webhook Rebuild ?",
                subTitle: "Are you sure you want to rebuild this webhook? This action will regenerate the webhook, which may affect any active integrations.",
                cancelButton: "Cancel",
                saveButton: "Save",
                onConfirm: () => {
                    api.post(process.env.REACT_APP_API_URI + `/api/project_env/create-webhook/`, {
                        "repo_name": data?.source !== "gitlab" ? data?.repo : data?.repo_id,
                        "vcs_account_id": data?.accountId,
                        "project_service_id": data?.serviceId
                    }).then((res) => {
                        let data = res.data;
                        if (data.status) {
                            if (data.data.status) {
                                toggleAlert("success", "Success", data.data.message);
                                currentProject.tasks.forEach((temp, idx) => {
                                    if (temp && (temp.serviceId === myAppData.serviceId)) {
                                        currentProject.tasks[idx] = { ...myAppData, webhook_info: "true" };
                                    }
                                });
                                setCurrentProject({ ...currentProject });
                                localStorage.setItem("Project", JSON.stringify({ ...currentProject }))
                            }
                            else {
                                toggleAlert("error", "Error", data.data.message);
                            }
                        }
                        else {
                            toggleAlert("error", "Error", "Something went wrong. Please try again.");
                        }
                    }).catch((err) => {
                        toggleAlert("error", "Error", "Something went wrong. Please try again.");
                    }).finally(() => {
                        handelClick();
                        setOpenModel({
                            modalType: '',
                            modalProps: {
                                data: null,
                                columnId: null,
                            },
                        });
                    });
                },
                onCancel: () => {
                    setOpenModel({
                        modalType: '',
                        modalProps: {
                            data: null,
                            columnId: null,
                        },
                    });
                }
            }
        });
    }

    const handleBlur = (item, value) => {
        console.log('handleBlur :', item);
        console.log('handleBlur value :', value);
        // Perform any logic you need here, e.g. validating selections, updating state, etc.
        // setBranchSearchValue("");
        // setAutomaticBranches([]);
        // setPageCount(1);
        if (branchSearchValue !== "") {
            setPageCount((prev) => {
                setBranchSearchValue("");
                setBranches([]);
                setAutomaticBranches([]);
                setDoneFetching(false);
                return 1
            });
        }
    };

    const handlePopupScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

        // console.log('scrollTop :', scrollTop);
        // console.log('scrollHeight :', scrollHeight);
        // console.log('clientHeight :', clientHeight);
        // console.log('fetchingBranches :', fetchingBranches);

        if (!doneFetching && (scrollHeight - scrollTop <= clientHeight + 10) && !fetchingBranches) {
            // load more
            console.log('Custom onScroll fired');

            setPageCount(pageCount + 1);
            setFetchingBranches(true);
        }
    };


    return (
        <>
            {/* <Alert
                message={alertOptions.message}
                description={alertOptions.description}
                type={alertOptions.type}
                showIcon
                style={alertOptions.status ? marginsBot : fadeMarginBot}
            /> */}
            <CustomModal
                visible={componentLoading}
                //onCancel={hideModal}
                footer={null}
                closable={false}
                centered
                maskClosable={false}
                style={{ border: "none", boxShadow: "none", zIndex: componentLoading ? 1100 : -1 }}
            >
                <div style={{ textAlign: 'center', background: "transparent", border: "none" }}>
                    <Spin size="large" />
                </div>
            </CustomModal>

            <Form
                form={form}
                initialValues={{ ...myAppData }}
                preserve={false}
                name="dynamic_rule"
                style={{
                    marginTop: "100px"
                }}
            >
                <CreateTaskHeader
                    buttonContent={columnId}
                    editing={editing}
                    values={values}
                    onCancel={handelClick}
                    onDelete={onDelete}
                    onEditCancel={onEditCancel}
                    onSave={handelSaveTask}
                    onUpdate={handelUpdateTask}
                />

                {console.log("My data source: ", data?.source)}
                {editing && !data?.webhook_info && data?.app_source_type === 1 && data?.source !== "public" && <CustomAlert
                    showIcon
                    type="warning"
                    message="Attention"
                    description={
                        <div style={{ display: "flex", flexDirection: "column", height: "60px" }}>
                            <p>CI/CD for automatic triggers wont work for this service. Click below to recreate webhook.</p>
                            <div style={{ position: "absolute", top: "80px", right: "20px" }}>
                                <Button style={{
                                    border: "1px solid #163247",
                                    background: "transparent",
                                    color: "#163247",
                                    height: "30px",
                                    width: "101px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }} onClick={() => {
                                    retriggerWebhook();
                                }}>
                                    <img src={retriggerIcon} style={{ height: "14px", marginRight: "5px" }} />
                                    <span>Recreate</span>
                                </Button>
                            </div>
                        </div>}
                    closable
                    style={{ margin: "20px" }}
                />}
                <div style={{ padding: "0 20px" }}>
                    {/* <Box
                        title={"App Name*"}
                        subtitle={"Enter the name of the application service (e.g., Frontend, Backend)."}
                        style={boxStyle}
                        titleStyle={titleStyle}
                        subtitleStyle={subtitleStyle}
                        imgStyle={imgStyle}
                    >
                        <Input
                            name="name"
                            value={myAppData.name}
                            onChange={handelChange}
                            placeholder="App Name"
                            style={inputStyle}
                        />
                    </Box> */}

                    <Box
                        title={"Application Source Type*"}
                        subtitle={"Specify the source or origin of the application service code (e.g., Git repository URL)."}
                        style={{ ...boxStyle, position: "relative" }}
                        titleStyle={titleStyle}
                        subtitleStyle={subtitleStyle}
                    >
                        <Form.Item
                            name="sourceType"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please provide application source type.',
                                },
                            ]}
                        >
                            <Select
                                className="customSelectDataSource"
                                style={{ width: '100%', opacity: myAppData?.fromLogsPage ? "0.5" : "1", cursor: myAppData?.fromLogsPage ? "not-allowed" : "auto", pointersEvent: "none" }}
                                value={myAppData.sourceType}
                                // open={openSource}
                                onChange={handleSelectChange}
                                disabled={infraModuleData?.fromLogsPage || sourceLocked}
                            // onClick={(e) => handleSource(e, true)}
                            // onBlur={(e) => handleSource(e, false)}
                            >
                                {sourceList}
                            </Select>
                        </Form.Item>
                    </Box>

                    {myAppData.sourceType === "Git Repositories" && <Box
                        title={"Git Source*"}
                        subtitle={"Select git source here"}
                        style={{ ...boxStyle, position: "relative" }}
                        titleStyle={titleStyle}
                        subtitleStyle={subtitleStyle}
                        imgStyle={imgStyle}
                    >
                        {/* <Form.Item
                            name="source"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please provide git source.',
                                },
                            ]}
                        > */}
                            {/* {console.log("myAppData.source :", myAppData.source)}
                            {console.log("myAppData.accountName :", myAppData.accountName)}
                            {console.log("form.accountName :", form.getFieldValue("accountName"))} */}
                            <Select
                                className="customSelectDataSource"
                                style={{ width: '100%', height: "40px" }}
                                value={myAppData.source ?
                                    `${myAppData.source.toUpperCase()}${myAppData.accountName ? ` (${myAppData.accountName})` : ""}`
                                    :
                                    undefined
                                }
                                onChange={handleSelectChange}
                                disabled={infraModuleData?.fromLogsPage || sourceLocked}
                                onPopupScroll={handleAccountsPopupScroll}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                dropdownRender={(menu) => (
                                    <div>
                                        {(!accountsConnected || accountsConnected.length === 0) && accountsFetching ? (
                                            <div style={{ textAlign: 'center', padding: 8 }}>
                                                <Spin size="small" />
                                            </div>
                                        ) : (menu)}
                                        {!doneFetchingAccounts && accountsConnected?.length > 0 && accountsFetching && (
                                            <div style={{ textAlign: 'center', padding: 6 }}>
                                                <Spin size="small" />
                                            </div>
                                        )}
                                    </div>
                                )}
                            >
                                {sourceFetching && !accountsConnected ?
                                    <Option>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                            <Spin size="small" />
                                        </div>
                                    </Option>
                                    :
                                    accountsConnected
                                }
                            </Select>
                        {/* </Form.Item> */}
                        {openAppSourceDropdown && <img src={refreshIcon} style={{ position: "absolute", top: "10px", right: "0", cursor: "pointer" }} onClick={handleAppSourceRefresh} />}
                    </Box>}

                    {myAppData.source && <>
                        {myAppData.source === "public" && myAppData.sourceType === "Git Repositories" && <Box
                            title={
                                <div style={{ display: "flex" }}>
                                    <span>Public Repo Url*</span>
                                    <CustomInfoTooltip title={"If it is a monorepo, please add each Terraform workspace individually using the same repository, with the appropriate workspace configuration for each one."} placement={"bottomLeft"} style={{ marginLeft: "10px" }} />
                                </div>
                            }
                            subtitle={"Repo Url Details"}
                            style={boxStyle}
                            titleStyle={titleStyle}
                            subtitleStyle={subtitleStyle}
                            imgStyle={imgStyle}
                        >
                            <Form.Item
                                name="repoUrl"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please provide repo url.',
                                    },
                                    {
                                        validator: (_, value) => {
                                            // console.log("repoUrlRegex.test(value) :", repoUrlRegex.test(value));
                                            if (value && value.length > 1 && (!repoUrlRegex.test(value) || !value.endsWith(".git"))) {
                                                return Promise.reject(new Error(`Please provide correct repo url.`));
                                            }

                                            return Promise.resolve();
                                        }
                                    },
                                ]}
                            >
                                <Input
                                    name="repoUrl"
                                    value={myAppData.repoUrl}
                                    onChange={handelChange}
                                    placeholder="Repo Url"
                                    style={inputStyle}
                                    disabled={infraModuleData?.fromLogsPage || sourceLocked}
                                // onBlur={getPublicBranches}
                                />
                            </Form.Item>
                            {/* {showError !== "" && <p className='isoHelperText'>{showError}</p>} */}
                        </Box>}

                        {myAppData.source != "public" && myAppData.sourceType === "Git Repositories" && <Box
                            title={"Repository*"}
                            subtitle={"Provide the URL or details of the code repository for the application service."}
                            style={boxStyle}
                            titleStyle={titleStyle}
                            subtitleStyle={subtitleStyle}
                            imgStyle={imgStyle}
                        >
                            <Form.Item
                                name="repo"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please provide repository.',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, searchValue)} // Custom sorting function
                                    filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function
                                    onSearch={(value) => {
                                        console.log("Enters search", value);
                                        setSearchValue(value);
                                    }}
                                    style={{ width: '100%', height: "40px" }}
                                    value={myAppData.repo}
                                    className="customSelectDataSource"
                                    onChange={handleSelectChange}
                                    optionLabelProp={myAppData.repo}
                                    disabled={infraModuleData?.fromLogsPage || sourceLocked}
                                //filterOption={filterOption}
                                >
                                    {fetching ?
                                        <Option>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                                <Spin size="small" />
                                            </div>
                                        </Option>
                                        :
                                        repoList
                                    }
                                </Select>
                            </Form.Item>
                        </Box>}
                    </>}

                    {myAppData.repoUrl && <Box
                        title={`Build Type${myAppData?.fromLogsPage ? "" : "*"}`}
                        subtitle={"Select build type from the following."}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ ...boxStyle }}
                    >
                        <ContentHolder style={{ width: "100%", marginTop: "6px" }}>
                            <Form.Item
                                name="buildType"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please provide build type.',
                                    },
                                ]}
                            >
                                <Select
                                    name="buildType"
                                    value={myAppData?.buildType ? myAppData.buildType : undefined}
                                    placeholder="Select"
                                    onChange={handleSelectChange}
                                    style={{ width: "100%", height: "40px" }}
                                    className="customSelectDataSource"
                                    filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, searchValue)} // Custom sorting function
                                    filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function
                                    onSearch={(value) => {
                                        console.log("Enters search", value);
                                        setSearchValue(value);
                                    }}
                                    disabled={infraModuleData?.fromLogsPage || checkTryWithoutLogin}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                //filterOption={filterOption}
                                // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                >
                                    {autoTriggerOptions}
                                </Select>
                            </Form.Item>
                        </ContentHolder>
                    </Box>}

                    {myAppData.repoUrl && myAppData.buildType === "Automatic" && <Box
                        title={`Branch Configure${myAppData?.fromLogsPage ? "" : "*"}`}
                        subtitle={"Select branch configure from the following."}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ ...boxStyle }}
                    >
                        <ContentHolder style={{ width: "100%", marginTop: "6px", marginBottom: myAppData.branchConfig ? "auto" : "100px" }}>
                            <Form.Item
                                name="branchConfig"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please provide Branch Configure.',
                                    },
                                ]}
                            >
                                <Select
                                    value={myAppData?.branchConfig}
                                    placeholder="Select"
                                    onChange={handleSelectChange}
                                    style={{ width: "100%", height: "40px" }}
                                    className="customSelectDataSource"
                                    showSearch
                                    filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, searchValue)} // Custom sorting function
                                    filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function
                                    onSearch={(value) => {
                                        console.log("Enters search", value);
                                        setSearchValue(value);
                                    }}
                                    disabled={infraModuleData?.fromLogsPage || checkTryWithoutLogin}
                                //filterOption={filterOption}
                                // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                >
                                    {branchConfigDropdown}
                                </Select>
                            </Form.Item>
                        </ContentHolder>
                    </Box>}
                    {myAppData.repoUrl && myAppData.buildType !== "Automatic" && <Box
                        title={`Branch${myAppData?.fromLogsPage ? "" : "*"}`}
                        subtitle={"The branch a run checks out."}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ ...boxStyle }}
                    >
                        <ContentHolder style={{ width: "100%", marginTop: "6px" }}>
                            <Form.Item
                                name="branch"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please provide branch.',
                                    },
                                ]}
                            >
                                <Select
                                    name="branch"
                                    value={myAppData?.branch ? myAppData.branch : undefined}
                                    placeholder="Select"
                                    onChange={handleSelectChange}
                                    style={{ width: "100%", height: "40px" }}
                                    className="customSelectDataSource"
                                    // filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, branchSearchValue)} // Custom sorting function
                                    // filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function
                                    showSearch
                                    onSearch={(value) => {
                                        console.log("Enters search", value);
                                        debouncedFormUpdate(value);
                                    }}
                                    // virtual={false}
                                    onPopupScroll={handlePopupScroll}
                                    dropdownRender={(menu) => {
                                        // Return custom dropdown
                                        return (
                                            <div>
                                                {branches.length == 0 && fetchingBranches ? (
                                                    <div style={{ textAlign: 'center', padding: 8 }}>
                                                        <Spin size="small" />
                                                    </div>
                                                ) : (
                                                    /* If it’s not empty OR not fetching, show whatever AntD is going to show (filtered data or “No data”). */
                                                    menu
                                                )}

                                                {/* If you also have infinite scroll and want a loader at the bottom for “load more” scenarios: */}
                                                {!doneFetching && branches.length > 0 && fetchingBranches && (
                                                    <div style={{ textAlign: 'center', padding: 6 }}>
                                                        <Spin size="small" />
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    disabled={infraModuleData?.fromLogsPage || checkTryWithoutLogin}
                                //filterOption={filterOption}
                                // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                >
                                    {checkTryWithoutLogin ? <Option key="no-branches" style={{ background: "white" }} disabled>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "fit-content", padding: "3px 0" }}>
                                            <img src={noDataImg} alt="No data" />
                                            <span>No other branch</span>
                                        </div>
                                    </Option> : (pageCount <= 1 && fetchingBranches) ?
                                        <Option key="small-loader">
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                                <Spin size="small" />
                                            </div>
                                        </Option>
                                        :
                                        branches
                                    }
                                </Select>
                            </Form.Item>
                        </ContentHolder>
                    </Box>}
                    {myAppData.repoUrl && myAppData.buildType === "Automatic" && myAppData.branchConfig && <Box
                        title={`${myAppData.branchConfig}${myAppData?.fromLogsPage ? "" : "*"}`}
                        subtitle={`Select your ${myAppData.branchConfig}.`}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ ...boxStyle, marginBottom: "150px" }}
                    >
                        <ContentHolder style={{ width: "100%", marginTop: "6px" }}>
                            {myAppData.branchConfig === "Branch" &&
                                <Form.Item
                                    name={myAppData?.fromLogsPage ? "branch" : "branchConfigValue"}
                                    rules={[
                                        {
                                            required: true,
                                            message: `Please provide ${myAppData.branchConfig}.`,
                                        },
                                    ]}
                                >
                                    <Select
                                        id="branch-id"
                                        mode="multiple"
                                        name="branchConfigValue"
                                        value={myAppData?.fromLogsPage ? myAppData.branch : (myAppData?.branchConfigValue ? myAppData.branchConfigValue : [])}
                                        placeholder="Select"
                                        onChange={handleMultiSelectChange}
                                        style={{ width: "100%", height: "40px" }}
                                        showSearch
                                        onSearch={(value) => {
                                            console.log("Enters search", value);
                                            debouncedFormUpdate(value);
                                        }}
                                        onBlur={handleBlur}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        disabled={infraModuleData?.fromLogsPage || checkTryWithoutLogin}
                                        onPopupScroll={handlePopupScroll}
                                        dropdownRender={(menu) => {
                                            return (
                                                <div>
                                                    {automaticBranches.length == 0 && fetchingBranches ? (
                                                        <div style={{ textAlign: 'center', padding: 8 }}>
                                                            <Spin size="small" />
                                                        </div>
                                                    ) : (
                                                        menu
                                                    )}

                                                    {!doneFetching && automaticBranches.length > 0 && fetchingBranches && (
                                                        <div style={{ textAlign: 'center', padding: 6 }}>
                                                            <Spin size="small" />
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        }}
                                    >
                                        {checkTryWithoutLogin ? <Option key="no-branches" style={{ background: "white" }} disabled>
                                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "fit-content", padding: "3px 0" }}>
                                                <img src={noDataImg} alt="No data" />
                                                <span>No other branch</span>
                                            </div>
                                        </Option> : (pageCount <= 1 && fetchingBranches) ?
                                            <Option key="small-loader">
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                                    <Spin size="small" />
                                                </div>
                                            </Option>
                                            :
                                            automaticBranches
                                        }
                                    </Select>
                                </Form.Item>
                            }

                            {myAppData.branchConfig === "Wildcard Branch" &&
                                <Form.Item
                                    name={myAppData?.fromLogsPage ? "branch" : "branchConfigValue"}
                                    rules={[
                                        {
                                            required: true,
                                            message: `Please provide ${myAppData.branchConfig}.`,
                                        },
                                    ]}
                                >
                                    <Input
                                        name={"branchConfigValue"}
                                        value={myAppData?.fromLogsPage ? myAppData.branch : myAppData.branchConfigValue}
                                        onChange={handelChange}
                                        placeholder="Enter Value"
                                        style={{ ...inputStyle, cursor: myAppData?.fromLogsPage ? "not-allowed" : "auto", opacity: myAppData?.fromLogsPage ? "0.5" : "1", background: myAppData?.fromLogsPage ? "rgba(0, 0, 0, 0.04)" : "" }}
                                        disabled={infraModuleData?.fromLogsPage || checkTryWithoutLogin}
                                    // onBlur={getPublicBranches}
                                    />
                                </Form.Item>
                            }

                            {/* {myAppData.branchConfig === "Tags" && <Select
                                    value={myAppData?.branchConfigValue ? myAppData.branchConfigValue : undefined}
                                    placeholder="Select"
                                    onChange={handleSelectChange}
                                    style={{ width: "100%" }}
                                    className="customSelectDataSource"
                                    showSearch
                                    filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, searchValue)} // Custom sorting function
                                    filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function
                                    onSearch={(value) => {
                                        console.log("Enters search", value);
                                        setSearchValue(value);
                                    }}
                                    //filterOption={filterOption}
                                    // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                >
                                    {fetchingBranches ?
                                        <Option>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                                <Spin size="small" />
                                            </div>
                                        </Option>
                                        :
                                        branches
                                    }
                                </Select>} */}

                            {/* {myAppData.branchConfig === "Pull request" && <Select
                                    value={myAppData?.branchConfigValue ? myAppData.branchConfigValue : undefined}
                                    placeholder="Select"
                                    onChange={handleSelectChange}
                                    style={{ width: "100%" }}
                                    className="customSelectDataSource"
                                    showSearch
                                    filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, searchValue)} // Custom sorting function
                                    filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function
                                    onSearch={(value) => {
                                        console.log("Enters search", value);
                                        setSearchValue(value);
                                    }}
                                    //filterOption={filterOption}
                                    // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                >
                                    {fetchingBranches ?
                                        <Option>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                                <Spin size="small" />
                                            </div>
                                        </Option>
                                        :
                                        branches
                                    }
                                </Select>} */}

                            {/* {myAppData.branchConfig === "Wildcard Branch" &&
                                    <Form.Item
                                        name="branchConfigValue"
                                        rules={[
                                            {
                                                required: true,
                                                message: `Please provide ${myAppData.branchConfig}.`,
                                            },
                                        ]}
                                    >
                                        <Input
                                            name="branchConfigValue"
                                            value={myAppData.branchConfigValue}
                                            onChange={handelChange}
                                            placeholder="Enter Value"
                                            style={inputStyle}
                                            // onBlur={getPublicBranches}
                                        />
                                    </Form.Item>
                                } */}
                        </ContentHolder>
                    </Box>}

                    {/* <Box
                        title={"Min. CPU"}
                        subtitle={"Define the minimum CPU resources required for the application service."}
                        style={boxStyle}
                        titleStyle={titleStyle}
                        subtitleStyle={subtitleStyle}
                        imgStyle={imgStyle}
                    >
                        <Input
                            type="number"
                            name="cpu"
                            className="customInputBoxOnlyNumbers"
                            value={myAppData.cpu}
                            onChange={handelChange}
                            placeholder="100"
                            style={inputStyle}
                            suffix={"m"}
                        />
                    </Box>

                    <Box
                        title={"Min. RAM"}
                        subtitle={"Define the minimum RAM resources required for the application service"}
                        style={boxStyle}
                        titleStyle={titleStyle}
                        subtitleStyle={subtitleStyle}
                        imgStyle={imgStyle}
                    >
                        <Input
                            type="number"
                            name="ram"
                            className="customInputBoxOnlyNumbers"
                            value={myAppData.ram}
                            onChange={handelChange}
                            placeholder="500"
                            style={inputStyle}
                            suffix={"Mi"}
                        />
                    </Box> */}

                    {/* <Box
                        title={"Description"}
                        subtitle={"Provide a detailed description of the application service."}
                        style={{ ...boxStyle, marginBottom: data?.serviceId ? "10px" : "150px" }}
                        titleStyle={titleStyle}
                        subtitleStyle={subtitleStyle}
                        imgStyle={imgStyle}
                    >
                        <Textarea
                            name="description"
                            value={myAppData.description}
                            onChange={handelChange}
                            placeholder="Add a more detailed description..."
                            style={textAreaStyle}
                        />

                        {error.status && <p ref={targetRef} className="isoHelperText">
                            <span>{error.msg}</span>
                        </p>}
                    </Box> */}

                    {error.status && <p ref={targetRef} style={{ color: "red" }} className="isoHelperText">
                        <span>{error.msg}</span>
                    </p>}

                </div>

                {/* {console.log("showError :", showError)}
                {console.log("validatingRepo :", validatingRepo)} */}
                {!(infraModuleData?.fromLogsPage || checkTryWithoutLogin) && <CreateTaskFooter buttonContent={"Source Config"} givenButtonFunction1={handelSaveTask} givenButtonFunction2={handelClick} onCancel={handelClick} />}
            </Form>
        </>
    )
};
